<template>
    <div class="portfoliosTotal">
        <div class="ptValueInfos">
            <div class="ptValueCurrency">{{ allPortfoliosCurrency }}</div>
            <div class="ptValue">{{ allPortfoliosTotal }}</div>
        </div>
        <ValueAndChange v-bind="portfoliosTotalChange"></ValueAndChange>
    </div>
</template>

<script>
import ValueAndChange from '../controls/ValueAndChange.vue'
import DashboardOverviewMixin from '../home/dashboard/DashboardOverviewMixin';
import StockHtmlHelper from '../stocks/StockHtmlHelper';
export default {
	components: { ValueAndChange },
    mixins: [DashboardOverviewMixin],
    props: {
        total: {
            type: Object
        }
    },
    created() {
        this.stockHTMLHelper = new StockHtmlHelper()
    },
    computed: {
        allPortfoliosCurrency() {
            return this.total && this.total.currency ? this.total.currency.toUpperCase() : '';
        },
        allPortfoliosTotal() {
            return this.total ? this.stockHTMLHelper.formatLocalNumber(this.total.value, this.$i18n.locale) : '';
        },
        portfoliosTotalChange() {
            return this.total ? this.total.change : {};
            // return {
            //     val: this.total.change,
            //     chg: this.total.dayPrctChange ? this.total.dayPrctChange : 0,
            //     chgSymbol: "%",
            //     inverted: true
            // }
            //return this.totalChangeConverted({ portfolioList: this.total.aggregatedPortfolioStock, currency: this.total.currency });
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/breakpoints.scss";
.portfoliosTotal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ptValueInfos {
        display: flex;
        align-items: center;
        gap: 5px;
        .ptValueCurrency {
            font-size: 1.2em;
            font-weight: 500;
        }
        .ptValue {
            font-size: 2em;
            font-weight: 700;
        }
    }
    @media screen and (max-width: $small) {
        flex-direction: column;
    }
}
</style>